import { useMutation, useQueryClient } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { useSnackbar } from "src/utils/useSnackbar";
import { getOneActionPlanKey } from "../ActionPlan/useGetOneActionPlan";
import { getOneActionPlanActionsKey } from "./useGetOneActionPlanAction";
import { getAllActionPlanActionsKey } from "./useGetAllActionPlanAction";

type DeleteActionPlanAction = {
    actionPlanId: string | undefined;
    actionPlanActionId: string | undefined;
};

export const useDeleteActionPlanAction = () => {
    const snackbar = useSnackbar();
    const queryClient = useQueryClient();

    const query = useMutation({
        mutationFn: async (options: DeleteActionPlanAction) => {
            const { actionPlanId, actionPlanActionId } = options;

            snackbar.forceClose();
            snackbar.setSnackbarProps({
                type: "info",
                message: "Deleting the action in progress...",
            });

            const url = `/api/action_plans/${actionPlanId}/action/${actionPlanActionId}`;
            await loggedInApiCall.delete(url);
        },
        onSuccess: (_, variables) => {
            snackbar.forceClose();
            snackbar.setSnackbarProps({
                type: "success",
                message: "The action was succesfully deleted",
            });

            // Invalider toutes les queries liées aux actions pour synchroniser le cache
            queryClient.invalidateQueries([getOneActionPlanKey]);
            queryClient.invalidateQueries([getOneActionPlanActionsKey]);
            queryClient.invalidateQueries([getAllActionPlanActionsKey]);
        },
    });

    return query;
};
